import React from "react";
import SectionContainer from "../common/SectionContainer";

const steps = [
"Discover",
"Diagnose",
"Strategize",
"Execute",
"Optimize",
"Scale"
];

function GrowthFramework() {
return ( <SectionContainer background="#0d1b2a">

```
  <div className="framework-wrapper">

    <span className="framework-kicker">
      The EkritFly Growth System
    </span>

    <h2>
      A Structured Approach To
      Sustainable Business Growth
    </h2>

    <p>
      Every engagement follows a clear process
      designed to identify opportunities,
      remove bottlenecks and create scalable
      growth systems.
    </p>

    <div className="framework-timeline">
      {steps.map((step, index) => (
        <div
          key={step}
          className="framework-step"
        >
          <div className="framework-index">
            0{index + 1}
          </div>

          <h3>{step}</h3>
        </div>
      ))}
    </div>

  </div>

</SectionContainer>


);
}

export default GrowthFramework;
